export enum AnimationTypes {
  FADE = 'fade',
  SLIDE = 'slide',
  PARALLAX = 'parallax',
}

export enum AnimationEases {
  EASE = 'ease',
  EASE_IN = 'ease-in',
  EASE_OUT = 'ease-out',
  EASE_IN_OUT = 'ease-in-out',
}

export enum AnimationDirection {
  UP = 'up',
  DOWN = 'down',
  LEFT = 'left',
  RIGHT = 'right',
}
